var FeedbackFactory = (options => {
  return () => {
    return {
      warning: options.translations.warnings.pwned,
      suggestions: [options.translations.suggestions.pwned]
    };
  };
});

export { FeedbackFactory as default };
